export default {
    // Provided by the user
    bestaetigteDiagnose: state => state.bestaetigteDiagnose,
    diagnoseConfirmed: state => state.diagnoseConfirmed,
    patientIsPregnant: state => state.patientIsPregnant,
    bestaetigteDiagnoseSelected: state => state.bestaetigteDiagnoseSelected,
    patientIsPregnantSelected: state => state.patientIsPregnantSelected,

    // Inferred by the algorithm
    vorgeschlageneDiagnose: state => state.vorgeschlageneDiagnose
}